export enum AmexAccountType {
  None  = 'None',
  MRPS = 'MRPS',
  PayFac = 'Payfac',
  Direct = 'Direct'
}
